import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from './utils';

class ExercisesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      exercises: [],
      loading: true,
    };
  }

  //once the component mounts get the list of all the exercises and diplay
  componentDidMount() {
    axios
      .get(`${BASE_URL}/exercises/`)
      .then((response) => {
        this.setState({
          exercises: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.setState({
      loading: false,
    });
  }

  deleteExercise(id) {
    this.setState({
      exercises: this.state.exercises.filter((el) => el._id !== id),
    });
    axios
      .delete(`${BASE_URL}/exercises/delete/${id}`)
      .then((response) => {
        alert('Success - user has been deleted!');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <h3>Logged Exercises</h3>
        {this.state.loading ? (
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        ) : (
          <table className='table'>
            <thead className='thead-light'>
              <tr>
                <th>Username</th>
                <th>Description</th>
                <th>Duration</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.state.exercises.map((exercise) => {
                return (
                  <tr key={exercise._id}>
                    <td>{exercise.username}</td>
                    <td>{exercise.description}</td>
                    <td>{exercise.duration}</td>
                    <td>{exercise.date.substring(0, 10)}</td>
                    <td>
                      <Link to={'/edit/' + exercise._id}>edit</Link>| |
                      <a
                        href='###'
                        className='text-danger'
                        onClick={() => {
                          this.deleteExercise(exercise._id);
                        }}
                      >
                        delete
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default ExercisesList;
